import { ReactElement, SVGProps } from 'react';
import BaseIcon from './BaseIcon';

export default function EventRepeatIcon(
  props: SVGProps<SVGSVGElement>
): ReactElement {
  return (
    <BaseIcon {...props}>
      <path d="M3.236 20.358q-.84 0-1.439-.598a1.96 1.96 0 0 1-.597-1.437V4.072q0-.84.598-1.438a1.96 1.96 0 0 1 1.439-.598h1.018V0h2.033v2.036h8.143V0h2.036v2.036h1.018q.84 0 1.438.598.599.598.599 1.438v6.108h-2.036V8.143H3.236v10.18h7.124v2.035zm14.25 2.036q-1.858 0-3.245-1.158a5 5 0 0 1-1.742-2.914h1.577a3.5 3.5 0 0 0 1.26 1.831 3.43 3.43 0 0 0 2.15.713q1.476 0 2.52-1.044 1.044-1.043 1.043-2.519 0-1.476-1.044-2.52a3.43 3.43 0 0 0-2.519-1.043q-.738 0-1.374.268a3.5 3.5 0 0 0-1.12.751h1.476v1.526h-4.072v-4.069h1.526v1.451q.688-.662 1.603-1.056a4.9 4.9 0 0 1 1.96-.395q2.113 0 3.6 1.488 1.489 1.49 1.489 3.601 0 2.112-1.488 3.601-1.489 1.488-3.6 1.488" fill="currentColor" />
    </BaseIcon >
  );
}
